import React, { useState, useEffect } from "react";
import { Select, HStack } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons"; 


const getMonthName = (month, language = 'en') => {
  if (language === 'mm') {
    const monthNames = {
      1: "ဇန်နဝါရီ",
      2: "ဖေဖော်ဝါရီ",
      3: "မတ်",
      4: "ဧပြီ",
      5: "မေ",
      6: "ဇွန်",
      7: "ဇူလိုင်",
      8: "ဩဂုတ်",
      9: "စက်တင်ဘာ",
      10: "အောက်တိုဘာ",
      11: "နိုဝင်ဘာ",
      12: "ဒီဇင်ဘာ"
    };
    return monthNames[month] || "Invalid month";
  }
  return new Date(2023, month - 1).toLocaleString(language, { month: "long" });
};

// Function to convert English numerals to Burmese
const convertToBurmeseNumerals = (number) => {
  const burmeseNumerals = ['၀', '၁', '၂', '၃', '၄', '၅', '၆', '၇', '၈', '၉'];
  return number.toString().replace(/[0-9]/g, (digit) => burmeseNumerals[digit]);
};

const MonthYearPicker = ({ onChange, language = 'en' }) => {
    // Get current date
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    // State for selected month & year
    const [selectedMonth, setSelectedMonth] = useState(currentMonth);
    const [selectedYear, setSelectedYear] = useState(currentYear);
  
    // Month options
    const months = selectedYear === currentYear
      ? [...Array(currentMonth)].map((_, i) => ({
          value: i + 1,
          label: getMonthName(i + 1, language),
        }))
      : [...Array(12)].map((_, i) => ({
          value: i + 1,
          label: getMonthName(i + 1, language),
        }));

    // Create an array with the current year and the 3 previous years
    const years = [currentYear, currentYear - 1, currentYear - 2, currentYear - 3];
  
    // Format year display based on language
    const formatYear = (year) => {
      return language === 'mm' ? convertToBurmeseNumerals(year) : year;
    };

    // Handle selection changes
    const handleMonthChange = (e) => {
      const newMonth = parseInt(e.target.value);
      setSelectedMonth(newMonth);
      onChange(newMonth, selectedYear);
    };
  
    const handleYearChange = (e) => {
      const newYear = parseInt(e.target.value);
      setSelectedYear(newYear);
      onChange(selectedMonth, newYear);
    };
  
    useEffect(() => {
      onChange(selectedMonth, selectedYear);
    }, [onChange, selectedMonth, selectedYear]);

    return (
      <HStack spacing={4}>
        <FontAwesomeIcon icon={faFilter} size="xl" />

        {/* Month Select Dropdown */}
        <Select value={selectedMonth} onChange={handleMonthChange} size="sm">
          {months.map((month) => (
            <option key={month.value} value={month.value}>
              {month.label}
            </option>
          ))}
        </Select>
  
        {/* Year Select Dropdown */}
        <Select value={selectedYear} onChange={handleYearChange} size="sm">
          {years.map((year) => (
            <option key={year} value={year}>
              {formatYear(year)}
            </option>
          ))}
        </Select>
      </HStack>
    );
};

// Helper function to get month name
// const getMonthName = (month) => {
//     return new Date(2023, month - 1).toLocaleString("default", { month: "long" });
// };

// const MonthYearPicker = ({ onChange }) => {
//     // Get current date
//     const currentDate = new Date();
//     const currentYear = currentDate.getFullYear();
//     const currentMonth = currentDate.getMonth() + 1; // Months are 0-indexed in JavaScript
  
//     // State for selected month & year
//     const [selectedMonth, setSelectedMonth] = useState(currentMonth);
//     const [selectedYear, setSelectedYear] = useState(currentYear);
  
//     // Month options: All months if selectedYear is previous, or up to the current month if it's the current year
//   const months = selectedYear === currentYear
//   ? [...Array(currentMonth)].map((_, i) => ({
//       value: i + 1,
//       label: getMonthName(i + 1),
//     })) // Show months up to the current month in the current year
//   : [...Array(12)].map((_, i) => ({
//       value: i + 1,
//       label: getMonthName(i + 1),
//     })); // Show all months for previous years
  
//     // Create an array with the current year and the 3 previous years
//     const years = [currentYear, currentYear - 1, currentYear - 2, currentYear - 3];
  
//     // Handle selection changes
//     const handleMonthChange = (e) => {
//       const newMonth = parseInt(e.target.value);
//       setSelectedMonth(newMonth);
//       onChange(newMonth, selectedYear);
//     };
  
//     const handleYearChange = (e) => {
//       const newYear = parseInt(e.target.value);
//       setSelectedYear(newYear);
//       onChange(selectedMonth, newYear);
//     };
  
//     // Trigger onChange on initial render to set default values
//     useEffect(() => {
//       onChange(selectedMonth, selectedYear);
//     }, [onChange, selectedMonth, selectedYear]); // Empty dependency array ensures this runs only once on mount
  
//     return (
//       <HStack spacing={4}>
//         <FontAwesomeIcon
//             icon={faFilter}
//             size="xl"
//         />

//         {/* Month Select Dropdown */}
//         <Select value={selectedMonth} onChange={handleMonthChange} size="sm">
//           {months.map((month) => (
//             <option key={month.value} value={month.value}>
//               {month.label}
//             </option>
//           ))}
//         </Select>
  
//         {/* Year Select Dropdown */}
//         <Select value={selectedYear} onChange={handleYearChange} size="sm">
//           {years.map((year) => (
//             <option key={year} value={year}>
//               {year}
//             </option>
//           ))}
//         </Select>
//       </HStack>
//     );
//   };

export default MonthYearPicker;
